import { render, staticRenderFns } from "./IconSelect.vue?vue&type=template&id=7402636f"
import script from "./IconSelect.vue?vue&type=script&lang=js"
export * from "./IconSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports